import { Button, Modal } from 'antd';
import React from 'react';

interface modal {
  visible: boolean;
  title: string;
  text?: string;
  textCancel?: string;
  hiddenCancelBtn?: boolean;
  textOk?: string;
  styleBackground?: string;
  styleColor?: string;
  url?: string;

  action_oke: React.MouseEventHandler<HTMLElement> | undefined;
  action_cancel?: React.MouseEventHandler<HTMLElement> | undefined;
}

const Popup = ({
  title,
  text,
  action_oke,
  action_cancel,
  visible,
  textCancel,
  hiddenCancelBtn,
  textOk,
  styleBackground,
  styleColor,
  url
}: modal) => {
  return (
    <div>
      <Modal
        visible={visible}
        closable={false}
        centered
        footer={[
          hiddenCancelBtn ? null : (
            <Button
              className="approve-button"
              key="back"
              onClick={action_cancel}
              style={{
                background: `${styleBackground}`,
                color: `${styleColor}`
              }}
              href={url}
            >
              {textCancel || 'Cancel'}
            </Button>
          ),
          <Button
            className="approve-button"
            key="submit"
            type="primary"
            onClick={action_oke}
          >
            {textOk || 'OK'}
          </Button>
        ]}
      >
        <h2>{title}</h2>
        <p>{text} </p>
      </Modal>
    </div>
  );
};

export default Popup;
